import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  const discount = Number(data?.discount || 0);
  const total = Number(data?.total_price || 0);

  const rows = [
    { label: `${t("pharmacy.patient")}:`, value: data?.patient_display || "-" },
    { label: `${t("pharmacy.doctor")}:`, value: data?.doctor_display || "-" },
  ];

  const totals = [{ label: t("pharmacy.total_price"), value: money(total + discount), bold: true }];

  if (discount > 0) {
    totals.push({ label: t("pharmacy.discount", "Discount"), value: money(discount) });
    totals.push({ label: t("pharmacy.afterDiscount", "After Discount"), value: money(total), color: "#0f766e" });
  }

  return (
    <ThermalReceipt
      ref={ref}
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      note={t("print.returnPolicyNote")}
      rows={rows}
      totals={totals}
      footerLines={[t("print.thanks"), t("print.getWellSoon"), t("print.cosmos")]}
    />
  );
});

export default Print;
